import React from 'react';
import WaterMeterInstallationPage from '../../water-meter-installation-page';

import wiringDiagram from '../../../../assets/product-interaction/joys550/joys550_wiring.jpg';

const JOYS550Installation = () => (
  <WaterMeterInstallationPage
    model="JOYS550"
    backUrl="/product/joys550"
    wiringDiagram={wiringDiagram}
    wiringAlt="JOYS550 水表通过 M-Bus 接入 GW214 采集器接线图"
  />
);

export default JOYS550Installation;
